export default "__VITE_ASSET__ChkNK61S__"